import {
  VIEW_IMAGE_MAX_DIMENSION,
  VIEW_IMAGE_QUALITY,
  VIEW_IMAGE_TYPE,
} from "./viewImageFormat";

/**
 * Encodes the whole source at its own aspect ratio, so the image matches what
 * the 3D viewer showed. Scaled down to the maximum view image dimension but
 * never up.
 */
export function encodeViewImage(source: HTMLCanvasElement): Promise<Blob> {
  const scale = Math.min(
    1,
    VIEW_IMAGE_MAX_DIMENSION / Math.max(source.width, source.height),
  );

  const canvas = document.createElement("canvas");
  canvas.width = Math.round(source.width * scale);
  canvas.height = Math.round(source.height * scale);

  const context = canvas.getContext("2d");
  if (!context) {
    return Promise.reject(
      new Error("Unable to get a 2D context to encode the view image."),
    );
  }
  context.imageSmoothingQuality = "high";
  context.drawImage(source, 0, 0, canvas.width, canvas.height);

  return new Promise((resolve, reject) =>
    canvas.toBlob(
      (blob) =>
        blob
          ? resolve(blob)
          : reject(new Error("Unable to encode view image.")),
      VIEW_IMAGE_TYPE,
      VIEW_IMAGE_QUALITY,
    ),
  );
}
